import { ResetPasswordParams, ResetPasswordResult } from '@/interfaces/auth/reset-password.interface';
import { mock, intercepter } from '../config';

mock.mock('/auth/reset-password', 'post', (config: any) => {
  const body = JSON.parse(config?.body) as ResetPasswordParams;
  return intercepter<ResetPasswordResult>({
    email: 'amitgroup@gmail.com'
  });
});
